// 在http.js中引入axios
import Vue from 'vue'
import axios from 'axios' // 引入axios
// import router from 'vue-router'
import QS from 'qs' // 引入qs模块，用来序列化post类型的数据，后面会提到
// 使用element-ui Loading做加载等待
import { Loading, Message } from 'element-ui' // 普通接口
/* 线上接口 */
Vue.prototype.$uploadUrl = 'http://www/lingyoutuo.com:8089/lingyoutuo/' // 本地接口
axios.defaults.baseURL = 'http://www/lingyoutuo.com:8089/lingyoutuo/' // 本地计算机
/* 本地接口 */
// Vue.prototype.$uploadUrl = 'http://192.168.2.101:8089' // 本地接口
// axios.defaults.baseURL = 'http://192.168.2.101:8089' // 本地计算机
/* 测试接口 */
// axios.defaults.baseURL = 'http://192.168.2.108:8088/lwylweb/' // 测试服务器
// Vue.prototype.$imageUrl = 'http://192.168.2.108:8088' // 本地接口
axios.defaults.timeout = 10000 // 请求超时时间
axios.defaults.headers.post['Content-Type'] =
  'application/x-www-form-urlencoded;charset=UTF-8'
let loading = null // 定义loading变量

// 开始 加载loading
const startLoading = () => {
  loading = Loading.service({
    lock: true,
    text: '加载中……',
    background: 'rgba(0, 0, 0, 0.1)'
  })
}
// 结束 取消loading加载
const endLoading = () => {
  loading.close()
}

// showFullScreenLoading() 与 tryHideFullScreenLoading() 目的是合并同一页面多个请求触发loading

let needLoadingRequestCount = 0 // 声明一个变量

const showFullScreenLoading = () => {
  if (needLoadingRequestCount === 0) {
    // 当等于0时证明第一次请求 这时开启loading
    startLoading()
  }
  needLoadingRequestCount++ // 全局变量值++
}

const tryHideFullScreenLoading = () => {
  if (needLoadingRequestCount <= 0) return // 小于等于0 证明没有开启loading 此时return
  needLoadingRequestCount-- // 正常响应后 全局变量 --
  if (needLoadingRequestCount === 0) {
    // 等于0 时证明全部加载完毕 此时结束loading 加载
    endLoading()
  }
}

// 请求拦截(请求发出前处理请求)
// http request 拦截器
axios.interceptors.request.use(
  config => {
    // 开启loading加载
    // console.log(localStorage.getItem('Token'))
    showFullScreenLoading()
    if (localStorage.getItem('Token')) {
      // 判断是否存在token，如果存在的话，则每个http header都加上token
      config.headers.accessToken = localStorage.getItem('Token')
    }
    return config
  },
  err => {
    endLoading()
    // router.push({
    //   path: '/login'
    // })
    return Promise.reject(err)
  }
)
// 响应拦截(请求后)
axios.interceptors.response.use(
  response => {
    // 关闭loading加载
    tryHideFullScreenLoading()
    if (response.data.status !== '0') {
      console.log(response.data.status)
      switch (response.data.status) {
        /**
         * 10001: 参数不合法
         * 传参时参数有误
         * **/
        case '10001':
          Message.error({
            message: response.data.msg
          })
          break
        /**
         * 10002: 未找到相关内容
         * 返回数据为空时
         * **/
        case '10002':
          Message.error({
            message: response.data.msg
          })
          break
        /**
         * 10003: 未找到相关内容
         * 返回数据为空时
         * **/
        case '10003':
          Message.error({
            message: response.data.msg
          })
          break
        /**
         * 用于用户登录时的状态
         * 20001: 用户不存在
         * **/
        case '20001':
          Message.error({
            message: response.data.msg
          })
          break
        /**
         * 20002: 用户手机号或密码不正确！
         * **/
        case '20002':
          Message.error({
            message: response.data.msg
          })
          break
        /**
         * 20000: 需要登录
         * **/
        case '20000':
          Message.error({
            message: response.data.msg
          })
          break
        default:
          break
        // 403 token过期
        // 登录过期对用户进行提示
        // 清除本地token和清空vuex中token对象
        // 跳转登录页面
      }
      return response
      // return Promise.reject(error.response)
    } else if (response.data.status === '0') {
      return response
    }
    // if (response.data.status == 10) {
    //   localStorage.removeItem('Token')
    //   // router.push({
    //   //   path: '/login'
    //   // })
    //   // console.log('对，走了。')
    //   // window.location.href = location.href.split('#')[0] + '#/login'
    // }
  },
  error => {
    endLoading()
    // localStorage.removeItem("Token");
    // router.push({
    //     path: '/login',
    // })
    // Message.error({
    //   message: '请求超时，请退出或刷新后重新登录再试'
    // })
    // if (error.response.status) {
    //     switch (error.response.status) {
    //         // 401: 未登录
    //         // 未登录则跳转登录页面，并携带当前页面的路径
    //         // 在登录成功后返回当前页面，这一步需要在登录页操作。
    //         case 401:
    //             router.replace({
    //                 path: '/login',
    //                 query: {
    //                     redirect: router.currentRoute.fullPath
    //                 }
    //             });
    //             break;

    //         // 403 token过期
    //         // 登录过期对用户进行提示
    //         // 清除本地token和清空vuex中token对象
    //         // 跳转登录页面
    //         case 403:

    //             // 清除token
    //             localStorage.removeItem('token');
    //             store.commit('loginSuccess', null);
    //             // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
    //             setTimeout(() => {
    //                 router.replace({
    //                     path: '/login',
    //                     query: {
    //                         redirect: router.currentRoute.fullPath
    //                     }
    //                 });
    //             }, 1000);
    //             break;

    //         // 404请求不存在
    //         case 404:

    //             break;
    //         // 其他错误，直接抛出错误提示
    //         default:
    //     }
    return Promise.reject(error.response)
    // }
  }
)
/**
 * post方法，对应post请求
 */
export function post(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, QS.stringify(params))
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err.data)
      })
  })
}
